import Plyr from 'plyr';
import { gsap } from 'gsap';

function VideoPlayer({ node }) {
	const shouldAutoplay = Boolean(node.hasAttribute('data-autoplay'));

	const plyrOpts = {
		settings: [],
		volume: 1,
		muted: false,
		keyboard: { focused: false },
		tooltips: { seek: false },
		loop: { active: true },
		hideControls: true,
		speed: { selected: 1, options: [] },
		fullscreen: { enabled: false, fallback: false },
		autopause: 0,
		autoplay: false,
	};

	if (shouldAutoplay) {
		plyrOpts.volume = 0;
		plyrOpts.muted = true;
		plyrOpts.loop = { active: true };
		plyrOpts.autoplay = true;
	}

	const player = new Plyr(node, plyrOpts);

	player.once('ready', () => {
		gsap.to(node, {
			opacity: 1,
			duration: 0.6,
			ease: 'linear',
		});
		if (shouldAutoplay) {
			player.volume = 0;
			player.muted = true;
			player.play();
		}
	});

	return () => {
		if (player) player.destroy();
	};
}

export default VideoPlayer;
